import { render, staticRenderFns } from "./OpenPaymentPay.vue?vue&type=template&id=a81f1cba&scoped=true&"
import script from "./OpenPaymentPay.vue?vue&type=script&lang=js&"
export * from "./OpenPaymentPay.vue?vue&type=script&lang=js&"
import style0 from "./OpenPaymentPay.vue?vue&type=style&index=0&id=a81f1cba&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81f1cba",
  null
  
)

export default component.exports